import type * as React from "react";

import { Chip, type ChipSize } from "./Chip";
import { cn } from "../lib/cn";

export interface ProgressChipProps extends Omit<
  React.HTMLAttributes<HTMLSpanElement>,
  "children"
> {
  done: number;
  total: number;
  size?: ChipSize;
  ref?: React.Ref<HTMLSpanElement>;
}

export function ProgressChip({
  done,
  total,
  size = "md",
  className,
  ...rest
}: ProgressChipProps) {
  const complete = total > 0 && done >= total;

  return (
    <span className={cn("inline-flex items-center gap-3", className)} {...rest}>
      <span aria-hidden="true" className="inline-flex gap-1">
        {Array.from({ length: total }, (_, i) => (
          <span
            key={i}
            className={cn(
              "h-2 w-[22px] rounded-full border",
              i < done
                ? "border-ink-recorded bg-fill-recorded"
                : "border-rule bg-wall",
            )}
          />
        ))}
      </span>
      <Chip tone={complete ? "recorded" : "brian"} size={size}>
        {done} of {total} done
      </Chip>
    </span>
  );
}
